import { Outlet } from "react-router-dom";
import { Alert, Box } from "@dealer-center/core-components";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { Locale } from "@dealer-center/ddc-core-utils";
import LABELS from "./labels.json";

export const Configuration = () => {
  const { "ddc-configuration-access": hasPageAccess } = useCC9Flags();
  Locale.setLabelsOnce(LABELS);

  // `=== false` on purpose: flags are `undefined` until the LD client initializes.
  if (hasPageAccess === false) {
    return (
      <Alert sx={{ marginBottom: "16px" }} type="error">
        {String(Locale.getText("NO_ACCESS"))}
      </Alert>
    );
  }

  return (
    <Box>
      <Outlet />
    </Box>
  );
};
